import FlowFoldersAPI from '../api/flowFolders';

const state = {
  folders: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getFolders: s => s.folders,
  getUIFlags: s => s.uiFlags,
};

const actions = {
  fetch: async ({ commit }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await FlowFoldersAPI.index();
      commit('SET_FOLDERS', response.data.data ?? []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  create: async ({ commit }, payload) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await FlowFoldersAPI.create(payload);
      const folder = response.data.data;
      commit('ADD_FOLDER', folder);
      return folder;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { id, name }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await FlowFoldersAPI.update(id, { name });
      const folder = response.data.data;
      commit('UPDATE_FOLDER', folder);
      return folder;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  destroy: async ({ commit }, id) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await FlowFoldersAPI.destroy(id);
      commit('REMOVE_FOLDER', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG: (s, flags) => {
    s.uiFlags = { ...s.uiFlags, ...flags };
  },
  SET_FOLDERS: (s, folders) => {
    s.folders = folders;
  },
  ADD_FOLDER: (s, folder) => {
    s.folders.push(folder);
  },
  UPDATE_FOLDER: (s, folder) => {
    const idx = s.folders.findIndex(f => f.id === folder.id);
    if (idx !== -1) s.folders.splice(idx, 1, folder);
  },
  REMOVE_FOLDER: (s, id) => {
    s.folders = s.folders.filter(f => f.id !== id);
  },
};

export default { namespaced: true, state, getters, actions, mutations };
